// src/components/Navbar.js
import React from 'react'; // Hapus useState karena sudah tidak digunakan
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

function Navbar({ onToggleSidebar, className }) {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.logout();
    navigate('/login');
  };

  const isCollapsed = className === 'collapsed';

  return (
    <nav className={`navbar ${className || ''}`}>
      {/* Toggle button di kanan atas */}
      <button className="sidebar-toggle-icon" onClick={onToggleSidebar}>
        {isCollapsed ? '>' : '<'}
      </button>
      {/* Bagian atas navbar (link navigasi) */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link to="/" className="nav-link">Dashboard</Link>
        </li>
        <li className="nav-item">
          <Link to="/summary" className="nav-link">Summary</Link>
        </li>
        <li className="nav-item">
          <Link to="/transaction" className="nav-link">Transaction</Link>
        </li>
        <li className="nav-item">
          <Link to="/transaction-detail" className="nav-link">Transaction Detail</Link>
        </li>
        
        {/* Top Issuer: admin & viewer */}
        {auth.user && (auth.user.role === 'admin' || auth.user.role === 'viewer') && (
          <li className="nav-item">
            <Link to="/top-issuer" className="nav-link">Top Issuer</Link>
          </li>
        )}

        {/* Tampilkan link HANYA jika peran user adalah 'admin' */}
        {auth.user && auth.user.role === 'admin' && (
          <> {/* Gunakan Fragment <> untuk mengelompokkan beberapa item */}
            <li className="nav-item">
              <Link to="/master-data" className="nav-link">Master Data</Link>
            </li>
            <li className="nav-item">
              <Link to="/sync" className="nav-link">Sync Data</Link>
            </li>
            <li className="nav-item">
              <Link to="/users" className="nav-link">Users</Link>
            </li>
            <li className="nav-item">
              <Link to="/merchant-report" className="nav-link">Merchant Report</Link>
            </li>
          </>
        )}
      </ul>

      {/* Bagian bawah navbar (info user dan aksi) */}
      <div className="navbar-footer">
        {/* Tampilkan info user dan tombol logout jika sudah login */}
        {auth.user ? (
          <>
            <div className="user-info">
              <span className="user-email">{auth.user.email}</span>
              <span className="user-role">{auth.user.role}</span>
            </div>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </>
        ) : (
          // Fallback jika belum login
          <Link to="/login" className="nav-link">Login</Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar;